import { render, staticRenderFns } from "./ebookinfo.html?vue&type=template&id=d37d9c8a&scoped=true&"
import script from "./ebookinfo.js?vue&type=script&lang=js&"
export * from "./ebookinfo.js?vue&type=script&lang=js&"
import style0 from "./ebookinfo.sass?vue&type=style&index=0&id=d37d9c8a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37d9c8a",
  null
  
)

component.options.__file = "ebookinfo.vue"
export default component.exports